import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model";
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { ActionSheetController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { Subject } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-qs-mhada",
  templateUrl: "./qs-mhada.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsMhadaComponent implements OnInit {
  questionCode: string = 'Q_MHADA';
  @Input() activeLang: string = "";
  @Input() ocrToBeDone: boolean;
  questionRequest: QuestionRequest;
  progressSpinnerDialog: any = null;
  @Output() proceedNext = new EventEmitter();
  @Output() routeToCertEntry = new EventEmitter();
  uploadFileVisible: boolean = false;
  reUploadFileVisible: boolean = false;
  fileObj: File;
  selectedImage: string = '';
  errorMessageVisible: boolean = false;
  errorMessage: string = '';
  proceedEnabled: boolean = false;
  ocrStatus: boolean = false;
  ocrEntryKey: number;
  selectedRadioOption: string;
  dirtyForm: boolean = false;
  callOcr: Subject<File> = new Subject();
  pmayPattern: string = "^PMAY/\\d{4}-\\d{2}/\\d+$";
  applicationNo: string = "";
  constructor(private registrationStepService: RegistrationStepService, private dialog: MatDialog,
    public actionSheetController: ActionSheetController, private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    if (localStorage.getItem("editQuestionCode") && localStorage.getItem("editQuestionCode") === this.questionCode) {
      this.displayProgressSpinner();
      this.registrationStepService.fetchQuestionDetail(this.questionCode)
        .subscribe((data) => {
          this.closeProgressSpinner();
          if (data.status === 'SUCCESS') {
            if (data.mhadaEmployeeResponse) {
              this.selectedRadioOption = data.mhadaEmployeeResponse.answer;
              if (this.selectedRadioOption === 'Yes') {
                this.fetchMhadaEmployeeCertificate();
              }
              else {
                this.evaluateProceed();
              }
            }
            else {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
          }
          else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          this.closeProgressSpinner();
          this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
        });
    }
    else {
      localStorage.removeItem("editQuestionCode");
      this.proceedNext.emit();
    }
  }

  fetchMhadaEmployeeCertificate() {
    console.log('test');
    this.registrationStepService.fetchQuestionDoc(this.questionCode)
      .subscribe((data) => {
        this.closeProgressSpinner();
        if (data.status === 'SUCCESS') {
          const byteArray = new Uint8Array(
            atob(data.fileBase64)
              .split("")
              .map((char) => char.charCodeAt(0))
          );
          let blob = new Blob([byteArray], { type: "image/png" });
          this.uploadFileVisible = true;
          this.selectedImage = URL.createObjectURL(blob);
          this.ocrStatus = true;
          this.evaluateProceed();
        }
        else {
          this.registrationStepService.showErrorMessage(data.errorMessage, true);
        }
      }, error => {
        this.closeProgressSpinner();
      });
  }

  async proceed() {
    if (this.dirtyForm) {
      if (this.evaluateProceed()) {
        this.displayProgressSpinner();
        this.questionRequest = {
          csmcApplicantRequestBody: {
            answer: this.selectedRadioOption,
            applicationNo: this.selectedRadioOption === 'Yes' ? this.applicationNo : null
          }
        };
        this.registrationStepService.saveQuestion(this.questionCode, this.questionRequest)
          .subscribe((data) => {
            this.closeProgressSpinner();
            if (data.status === 'SUCCESS') {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
            else {
              this.registrationStepService.showErrorMessage(data.errorMessage, true);
            }
          }, error => {
            console.log(error);
            this.closeProgressSpinner();
            this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
          });
      }
      else {
        this.registrationStepService.frontendWarningToast("error-mandatory-fields", false);
      }
    }
    else {
      this.displayProgressSpinner();
      this.registrationStepService.proceedWithoutSave(this.questionCode)
        .subscribe((data) => {
          this.closeProgressSpinner();
          if (data.status === 'SUCCESS') {
            if (data.questionCode) {
              localStorage.setItem("editQuestionCode", data.questionCode);
              this.proceedNext.emit();
            }
            else {
              localStorage.removeItem("editQuestionCode");
              this.proceedNext.emit();
            }
          }
          else {
            this.registrationStepService.showErrorMessage(data.errorMessage, true);
          }
        }, error => {
          console.log(error);
          this.closeProgressSpinner();
          localStorage.removeItem("editQuestionCode");
          this.proceedNext.emit();
        });
    }
  }

  radioButtonClicked(event) {
    this.dirtyForm = true;
    if (event == 'Yes') {
      this.uploadFileVisible = true;
    }
    else if (event == 'No') {
      this.uploadFileVisible = false;
    }
    this.evaluateProceed();
  }

  setSelectedImage(event) {
    this.selectedImage = event;
  }

  setFileObj(event) {
    console.log(event);
    this.fileObj = event;
    this.callOcr.next(this.fileObj);
  }

  setOcrStatus(event) {
    this.ocrStatus = event;
  }

  setOcrEntryKey(event) {
    this.ocrEntryKey = event;
  }

  routeToCertEntryFn() {
    this.routeToCertEntry.emit();
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async closeProgressSpinner() {
    if (this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }

  evaluateProceed() {
    this.proceedEnabled = false;
    if (this.selectedRadioOption == 'Yes') {
      if (this.applicationNo && this.applicationNo.trim().length > 0 && !this.errorMessageVisible) {
        this.proceedEnabled = true;
      }
    }
    else {
      if (this.selectedRadioOption == "No") {
        const msg = this.translocoService.translate('alerts.notAllowed');
        alert(msg);
        this.proceedEnabled = false;
      }
    }
    return this.proceedEnabled;
  }

  //   evaluateProceed() {
  //   this.proceedEnabled = false;

  //   // validate Application Number using regex
  //   const pmayRegex = new RegExp(this.pmayPattern);
  //   if (this.applicationNo && pmayRegex.test(this.applicationNo)) {
  //     this.proceedEnabled = true;
  //   }

  //   return this.proceedEnabled;
  // }



  // onApplicationNumberChange() {
  //   this.errorMessageVisible = false;
  //   this.errorMessage = '';

  //   if (this.applicationNo && this.applicationNo.trim().length > 0) {
  //     this.registrationStepService.validateApplicationNumber(this.applicationNo)
  //       .subscribe((response: any) => {
  //         if (response.status === 'SUCCESS' && response.exists) {
  //           // Application No valid
  //           this.proceedEnabled = true;
  //           this.errorMessageVisible = false;
  //         } else {
  //           // Not valid
  //           this.proceedEnabled = false;
  //           this.errorMessageVisible = true;
  //         this.errorMessage = this.translocoService.translate('errors.invalidApplicationNumber');
  //         }
  //       }, error => {
  //         this.proceedEnabled = false;
  //         this.errorMessageVisible = true;
  //       this.errorMessage = this.translocoService.translate('errors.errorValidatingApplicationNumber');
  //       });
  //   } else {
  //     this.proceedEnabled = false;
  //   }
  // }

  onApplicationNumberChange() {
    this.applicationNo = this.applicationNo.toUpperCase(); // 🔥 new line for uppercase always

    this.errorMessageVisible = false;
    this.errorMessage = '';

    if (this.applicationNo && this.applicationNo.trim().length > 0) {
      this.registrationStepService.validateApplicationNumber(this.applicationNo)
        .subscribe((response: any) => {
          if (response.status === 'SUCCESS' && response.exists) {
            this.proceedEnabled = true;
            this.errorMessageVisible = false;
          } else {
            this.proceedEnabled = false;
            this.errorMessageVisible = true;
            this.errorMessage = this.translocoService.translate('errors.invalidApplicationNumber');
          }
        }, error => {
          this.proceedEnabled = false;
          this.errorMessageVisible = true;
          this.errorMessage = this.translocoService.translate('errors.errorValidatingApplicationNumber');
        });
    } else {
      this.proceedEnabled = false;
    }
}
  formatApplicationNo(value: string) {
  this.applicationNo = value.toUpperCase();
}
}